import { render, staticRenderFns } from "./dic_process_edit.vue?vue&type=template&id=0898c86c&scoped=true"
import script from "./dic_process_edit.vue?vue&type=script&lang=js"
export * from "./dic_process_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0898c86c",
  null
  
)

export default component.exports